import domReady from '@wordpress/dom-ready';

domReady(() => {
  const tabsBlock = document.querySelector('.campus-tabs');
  const contentElements = Array.from(
    document.querySelectorAll('.entry-content [data-campus-name]')
  );

  if (!tabsBlock || !contentElements.length) {
    return;
  }

  const tabs = tabsBlock.querySelectorAll('.tab-name');
  if (!tabs.length) {
    return;
  }

  // Show/hide content elements
  function toggleContentVisibility(elements, show) {
    elements.forEach((el) => {
      if (show) {
        el.classList.add('tab-content--visible');
        el.classList.remove('tab-content--not-visible');
      } else {
        el.classList.remove('tab-content--visible');
        el.classList.add('tab-content--not-visible');
      }
    });
  }

  // Step 1: Initialize all content elements as hidden
  contentElements.forEach((content) => {
    content.classList.add('tab-content--not-visible');
    content.classList.remove('tab-content--visible');
  });

  // Step 2: Tab click functionality
  tabs.forEach((tab) => {
    const tabName = tab.getAttribute('data-tab-name');

    tab.addEventListener('click', () => {
      tabs.forEach((t) => t.classList.remove('tab-name--active'));
      tab.classList.add('tab-name--active');

      // Show only the matching content and hide others using 'data-campus-name'
      contentElements.forEach((content) => {
        if (content.getAttribute('data-campus-name') === tabName) {
          toggleContentVisibility([content], true);
        } else {
          toggleContentVisibility([content], false);
        }
      });
    });
  });

  // Step 3: Set "default" tab and content.
  if (tabs[0]) {
    const defaultTab = tabs[0];
    defaultTab.classList.add('tab-name--active');

    const defaultTabName = defaultTab.getAttribute('data-tab-name');
    const defaultContent = contentElements.find(
      (el) => el.getAttribute('data-campus-name') === defaultTabName
    );
    if (defaultContent) {
      toggleContentVisibility([defaultContent], true);
    }
  }
});
